<template>
  <v-card class="widget-card">
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <div class="layout row ma-0 pa-2"  :style="{ backgroundColor: color }">
          <div class="sm4 xs4 flex">
            <div class="layout column justify-space-around align-center">
              <v-icon size="76px" color="white" style="opacity: 0.8;">{{icon}}</v-icon>
            </div>
          </div>
          <div class="layout column justify-space-around" style="color: white;">
            <span class="caption">{{ subTitle }}</span>
            <div class="headline" style="font-size: 3rem !important;">{{ title }}</div>
            <span class="caption">{{ supTitle }}</span>
          </div>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    supTitle: {
      type: [String, Number],
      required: false
    },
    subTitle: {
      type: [String, Number],
      required: false
    },
    title: {
      type: [String, Number],
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    }
  },

  data() {
    return {};
  }
};
</script>

<style>
.widget-card {
  border-radius: 5%;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
  background-color: transparent;
}

</style>
